import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({

  theme: {
    themes: {
      light: {
        primary: '#004187',
        secondary: '#005bb5',
        accent: '#FF6138',
        background: '#E5F1FE',

        white: '#FFFFFF',
        black: '#4d4d4d',


      },
    },
  },


});


